module.exports = __webpack_public_path__ + "static/media/Bakery Glaze.acef2039.jpg";